/**
 * @generated SignedSource<<355dad2064069c6121fcbbd462cb802d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "VoteButton_votable",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "remainingVotesCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "limitedVotesPerUser",
      "storageKey": null
    }
  ],
  "type": "Votable",
  "abstractKey": "__isVotable"
};

node.hash = "4568ad7b7a9f528da09c1d16a18b319e";

module.exports = node;
